import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Models
import mSimcard from 'models/simcard';
// Custom
import { getSimcardsAutocomplete } from 'actions';
import { simcardDataShape, autoCompleteDataShape } from 'constants/PropTypesShapes';
import AutoCompleteSearchFieldFilter from 'components/filters/AutoCompleteSearchFieldFilter';
import InformationItem from 'components/items/InformationItem';

const SimcardAutoCompleteItem = ({ element, onSelect }) => {
  if (element) {
    const simcard = { ...element };

    return (
      <div className="information-item-wrapper">
        <InformationItem
          icon={mSimcard.icon}
          label={simcard.number}
          value={simcard.iccid}
          onClick={() => onSelect(simcard)}
        />
      </div>
    );
  }
  return null;
};

SimcardAutoCompleteItem.propTypes = {
  element: simcardDataShape,
  onSelect: PropTypes.func,
};

SimcardAutoCompleteItem.defaultProps = {
  element: null,
  onSelect: null,
};

class SimcardAutoCompleteFilter extends React.Component {
  constructor(props) {
    super(props);

    this.handleGetSimcards = this.handleGetSimcards.bind(this);
    this.handleSelectElement = this.handleSelectElement.bind(this);
  }

  // Handlers
  handleGetSimcards(value, page) {
    const { handleGetSimcardsAutocomplete } = this.props;
    // Get default simcards list features
    const { defaultParams: { pagination, sort }, autoCompleteFilter } = mSimcard.listFeatures;
    // Define the page to be loaded
    const finalPagination = {
      page: page || pagination.page,
      pageSize: pagination.pageSize,
    };
    // Launch simcards loading
    const filter = { ...autoCompleteFilter, value };
    handleGetSimcardsAutocomplete(finalPagination, sort, [filter]);
  }

  handleSelectElement(simcard) {
    const { onSelect } = this.props;
    onSelect(simcard);
  }

  render() {
    const { simcard, simcards: { loading, elements, pagination } } = this.props;

    return (
      <AutoCompleteSearchFieldFilter
        label="field.simcard"
        element={simcard}
        loading={loading}
        elements={elements}
        pagination={pagination}
        elementComp={
          <SimcardAutoCompleteItem />
        }
        onGetElements={this.handleGetSimcards}
        elementDescBuilder={(element) => (element.iccid)}
        onSelectElement={this.handleSelectElement}
      />
    );
  }
}

SimcardAutoCompleteFilter.propTypes = {
  simcard: simcardDataShape,
  simcards: autoCompleteDataShape.isRequired,
  onSelect: PropTypes.func.isRequired,
  handleGetSimcardsAutocomplete: PropTypes.func.isRequired,
};

SimcardAutoCompleteFilter.defaultProps = {
  simcard: null,
};

const mapStateToProps = (state) => ({
  simcards: state.autoComplete.simcards,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetSimcardsAutocomplete: (pagination, sort, filters) => {
    dispatch(getSimcardsAutocomplete(pagination, sort, filters));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SimcardAutoCompleteFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/assets/main/SimcardAutoCompleteFilter.js